interface DefaultCurrencyType {
  currencyCode: string;
  symbol: string;
  name: string;
  image?: any;
}

export type ConfType = {
  downloadPDFAndCSV: boolean;
  askIsCardLostOrStolen: boolean;
  callCenterNumber: string;
  internationalCallCenterNumber: string;
  supportEmail: string;
  routesBlackList: string[];
  googlePlay?: string;
  appStore?: string;
  appName: string;
  privacyPolicyLink?: string;
  webAppLink?: string;
  defaultCurrencyConf?: DefaultCurrencyType;
  authStrategy: 'access-token' | 'refresh-token';
  currencyFirst?: boolean;
  profileDefaultImage?: any;
  switchBalanceFormatterSeparatorCommaDot?: boolean;
  psd2: boolean;
  hideReportPreview?: boolean;
  supporterMode?: boolean;
  googleAnalytics?: boolean;
  firstDayOfWeekMonday: boolean;
  multipleTabsSession: boolean;
  // Limits
  maxLimitPerTransactionCorporate?: number;
  maxDailyLimitCorporate?: number;
  maxMonthlyLimitCorporate?: number;
  maxLimitPerTransactionConsumer?: number;
  maxDailyLimitConsumer?: number;
  maxMonthlyLimitConsumer?: number;
  hideLimitsLabel?: boolean;

  LPLite?: boolean;
  pluginName?: string;
  LPLiteAccountType?: 'corporate' | 'consumer' | 'both';
  p2p?: boolean;
  mustSearchCompany?: boolean; // if true, force user to search company, if false, allow user to enter data manually
  hideCompanySearch?: boolean; // hide company search, force user to enter data manually
  contactSupportWording?: string;
  allowAddingNewAssociate?: boolean;
  otherQuestionsCurrencies: string[];
  hideCancelTransaction?: boolean;
  redirectOnTokenExpired?: boolean;
  twoFactorAuth?: boolean;
  batchPayment?: boolean;
  allowPDFTransactionsDownload?: boolean;
  downloadSingleTransaction?: boolean;
  associateText?: string;
  associateDetailsCheckbox?: boolean;
  createAccountTitle?: string;
  createPasswordTitle?: string;
  newPasswordLabel?: string;
  allowAccountSelectionPsd2?: boolean;
  reoccurringPayment?: boolean;
  repeatTransaction?: boolean;
  validateIban?: boolean;
  inactivityLockTimeout?: number;
  inactivityEndpointsBlacklist?: string[];
  defaultOnboardingPhoneNumber?: string;
};

export type ConfItemType = {
  [key in keyof ConfType]?: ConfType[key];
};

const configuration: ConfItemType = {
  routesBlackList: ['/welcome', '/profile', '/accounts'],
  authStrategy: 'refresh-token',
  currencyFirst: true,
  hideReportPreview: true,
  maxLimitPerTransactionCorporate: 50000,
  maxDailyLimitCorporate: 150000,
  maxMonthlyLimitCorporate: 300000,
  maxLimitPerTransactionConsumer: 2500,
  maxDailyLimitConsumer: 10000,
  maxMonthlyLimitConsumer: 25000,
  p2p: false,
  otherQuestionsCurrencies: ['GBP'],
  downloadSingleTransaction: false,
  associateText: 'associate',
  associateDetailsCheckbox: false,
  inactivityEndpointsBlacklist: ['notifications/count', 'chat/total-unread'],
};

export default configuration;
